import { StandardRecordForm } from './components/standard-record-form';
import { Schema } from './components/standard-record-form.schema';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useCreateStandardRecordMutation } from '../mutations';
import { useAuthentication } from '~/hooks/useAuthentication';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';

export const Page = withPrivateRoute(({ user }) => {
  const mutation = useCreateStandardRecordMutation();
  const { isSuperUser } = useAuthentication();
  const navigate = useNavigate();

  const defaultDistrict = user.permissions.districts_admin.length ? user.permissions.districts_admin[0].id : null;

  async function onSubmit(payload: Schema) {
    await mutation.mutateAsync({ ...payload, district: isSuperUser ? payload.district : defaultDistrict });
    navigate('/admin/standard-records');
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa standardrekord" />

      <PageLayout.Section>
        <StandardRecordForm
          isLoading={mutation.isPending}
          onSubmit={onSubmit}
          mode="create"
          defaultValues={{
            district: defaultDistrict,
            date: new Date().toISOString().split('T')[0],
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
});
